import * as React from "react";

import styles from './Header.module.css';

function Header() {
    return (
        <nav className={`${styles.navbar}`}>
            OQ Abre Hoje
        </nav>
    );
}

export default Header;